function Title({ title }: React.HTMLAttributes<HTMLDivElement>) {
  const titles = title?.split(' ');
  return (
    <div className="text-xl font-bold py-3 font-primary flex">
      <h3 className="">{titles?.[0]}</h3>
      {titles?.map((title, index) => {
        if (index === 0) return <div key={index}></div>;
        return <h3 key={index}>&nbsp;{title}</h3>;
      })}
    </div>
  );
}

export { Title };
